import React, { FC, useContext, useEffect } from 'react';
import { useCommon } from '../../../../contexts/CommonContext';
import DailyActiveUsersContext from '../../../../contexts/DailyActiveUsersContext';
import { useContentLocalizer } from '../../../../hooks/useContentLocalizer';
import DailyActiveUserUsage from '../../../DailyActiveUsers/components/DailyActiveUserUsage';
import { localization } from '../../localization';

const DailyUsageComponent: FC = () => {
  const { dateToSearch, tenant } = useContext(DailyActiveUsersContext);
  const { setHeaderContent } = useCommon();
  const content = useContentLocalizer(localization);

  useEffect(() => {
    setHeaderContent({
      redirect: '/daily-active-users',
      text: content.formatString(content.header, tenant.info.name),
    });

    return () => setHeaderContent({ redirect: null });
  }, [dateToSearch]);

  return <DailyActiveUserUsage tableBodyHeight="1000px" registersToTake={-1}></DailyActiveUserUsage>;
};

export default DailyUsageComponent;
